"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fromRaw_1 = __importDefault(require("../serialize/fromRaw"));
const change_1 = __importDefault(require("../change/change"));
const fromText_1 = __importDefault(require("../serialize/fromText"));
const change_2 = require("../change");
const emptyList = {
    value: [],
};
class EditorState {
    constructor({ start = 0, end = 0, anchorOffset, focusOffset, list = emptyList, lastChangeType = null, currentStyles = [], undoStack = [], redoStack = [], }) {
        this.redoStack = [];
        this.undoStack = [];
        this.list = list;
        this.undoStack = undoStack;
        this.currentStyles = currentStyles;
        this.anchorOffset = typeof anchorOffset === 'number' ? anchorOffset : start;
        this.focusOffset = typeof focusOffset === 'number' ? focusOffset : end;
        let [_start, _end] = [this.anchorOffset, this.focusOffset].sort((a, b) => a - b);
        this.start = _start;
        this.end = _end;
        this.lastChangeType = lastChangeType;
        this.redoStack = redoStack;
    }
    change(_change) {
        const start = (typeof _change.start === 'number' ? _change.start : this.start) + 1;
        const end = (typeof _change.end === 'number' ? _change.end : this.end) + 1;
        const defaultChange = {
            start: this.start,
            end: this.end,
            value: this.list.value.slice(start, end)
        };
        const update = {
            current: this.list,
            change: Object.assign(Object.assign({}, defaultChange), _change)
        };
        const updated = change_1.default(update);
        let undoStack = this.undoStack;
        const [lastUndo, ...undoRest] = this.undoStack;
        const lastChangeType = _change.type || null;
        if (Boolean(_change.isBoundary) === false || this.undoStack.length === 0) {
            undoStack = [[updated.change].concat(lastUndo || [])].concat(undoRest);
        }
        else {
            undoStack = [[updated.change]].concat([lastUndo || []].concat(undoRest));
        }
        return new EditorState({
            start: updated.change.start - 1,
            end: updated.change.end - 1,
            currentStyles: this.currentStyles,
            lastChangeType,
            list: updated.current,
            redoStack: [],
            undoStack,
        });
    }
    undo() {
        return change_2.undo(this);
    }
    redo() {
        return change_2.redo(this);
    }
    setCurrentStyles(styles) {
        this.currentStyles = styles;
        return this;
    }
    toggleStyle(style, _start = this.start, _end = this.end) {
        const start = _start + 1;
        const end = _end + 1;
        const selectedValue = this.list.value.slice(start, end);
        const hasStyle = selectedValue.every(char => 'type' in char ||
            (char.styles || []).includes(style));
        const updatedValue = selectedValue.map(char => {
            const newChar = Object.assign({}, char);
            if ('char' in newChar) {
                if (hasStyle) {
                    newChar.styles = (newChar.styles || []).filter(st => st !== style);
                }
                else if (!(newChar.styles || []).includes(style)) {
                    newChar.styles = (newChar.styles || []).concat([style]);
                }
            }
            return newChar;
        });
        let newEditorState = this.change({
            isBoundary: true,
            value: updatedValue
        });
        newEditorState.start = _start;
        newEditorState.end = _end;
        if (!hasStyle || !this.currentStyles.includes(style)) {
            newEditorState.currentStyles = newEditorState.currentStyles.concat([style]);
        }
        else {
            newEditorState.currentStyles = newEditorState.currentStyles.filter(st => st !== style);
        }
        return newEditorState;
    }
    static fromJSON(json) {
        return new EditorState({
            list: fromRaw_1.default(json)
        });
    }
    static fromText(text) {
        return new EditorState({
            list: fromText_1.default(text),
        });
    }
}
exports.default = EditorState;
//# sourceMappingURL=EditorState.js.map